import React from 'react';
import * as R from 'ramda';
// components
import { EmptyList } from '../../../components/list';
import { LocalLoader } from '../../../components/local-loader';
// helpers/constants
import * as G from '../../../helpers';
// ui
import { Flex, StickedBox } from '../../../ui';
// feature
import InvoiceDetails from './invoice-details';
//////////////////////////////////////////////////

const renderInvoices = (props) => {
  const { data, closeModal, notesHidden, parentProps } = props;

  if (G.isNilOrEmpty(data)) {
    return (
      <EmptyList width='100%'>
        {G.getWindowLocale('titles:empty-list', 'Empty List')}
      </EmptyList>
    );
  }

  const {
    guid,
    editInvoice,
    addDocument,
    removeInvoice,
    documentTypes,
    openFixedPopup,
    closeFixedPopup,
  } = parentProps;

  return data.map((invoice, i) => (
    <InvoiceDetails
      {...invoice}
      closeModal={closeModal}
      notesHidden={notesHidden}
      documentTypes={documentTypes}
      openFixedPopup={openFixedPopup}
      closeFixedPopup={closeFixedPopup}
      edit={() => editInvoice(invoice, guid)}
      addDocument={() => addDocument(invoice, guid)}
      key={`master-invoice-invoice-${invoice.guid}-${i}`}
      actionsDisabled={R.pathOr(false, ['actionsDisabled'], props)}
      remove={(invoiceGuid, invoiceNumber) => removeInvoice(
        invoiceGuid,
        invoiceNumber,
        guid,
      )}
    />
  ));
};

const MasterInvoiceInvoices = (props) => (
  <StickedBox
    left='0px'
    display='inline-block'
    bg={G.getTheme('colors.white')}
    width={props.parentProps.detailsWidth}
  >
    <LocalLoader localLoaderOpen={props.parentProps.detailsLoading}>
      <Flex
        p={15}
        width='100%'
        flexWrap='wrap'
        border='1px solid'
        alignItems='baseline'
        borderColor={G.getTheme('colors.lightGrey')}
      >
        {renderInvoices(props)}
      </Flex>
    </LocalLoader>
  </StickedBox>
);

export default MasterInvoiceInvoices;
